import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppointmentService } from 'src/app/services/appointment.service';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { getSortableDate, getSortableTime } from 'src/app/utlis';

@Component({
  selector: 'app-inprogress-appointment-v2',
  templateUrl: './inprogress-appointment-v2.component.html',
  styleUrls: ['./inprogress-appointment-v2.component.scss'],
})
export class InprogressAppointmentV2Component implements OnInit {
  apptId: any;
  appointmentStatus: any;
  isApptCompleted: boolean = false;

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  @ViewChild(DataTableDirective)
  datatableElement: DataTableDirective;

  constructor(
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private http: HttpClient,
    private appointmentService: AppointmentService,
    private authenticationService: AuthenticationService,
    private authService: AuthenticationService,
    private router: Router
  ) {}

  value: String = 'Upcoming';
  appointments: any = [];
  userRole: any;
  status!: string;
  filterForm!: FormGroup;
  tests: any;
  surveys: any;
  selectedTests: any;
  selectedSurveys: any;
  disabledButton: boolean = false;
  show: boolean = false;
  schedules: any;
  page = 4;

  ngAfterViewInit(): void {
    this.dtTrigger.next(this);
  }

  rerender() {
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(this);
    });
  }

  ngOnInit(): void {
    let location = null;
    let diagId = null;
    this.status = 'ASSESMENT';
    this.show = false;
    jQuery('.modal-backdrop.fade.show').remove();
    this.spinner.show();

    this.userRole = this.authService.getUserType();
    if (this.userRole != 'ADMIN' && this.userRole != 'DIRECTOR') {
      diagId = this.authenticationService.getUserId();
    }
    this.loadAppointments(location, diagId);
  }

  loadAppointments(location: any, diagId: any) {
    this.appointmentService
      .getAppointments(location, diagId, this.status, null, null, null)
      .subscribe((res: any) => {
        this.appointments = res.data;

        if (this.appointments.length > 0) {
          this.appointments = this.appointments.sort(
            (a: any, b: any) =>
              new Date(
                b.appointmentDetails.schedules[0].appointmentDate
              ).getTime() -
              new Date(
                a.appointmentDetails.schedules[0].appointmentDate
              ).getTime()
          );
        } 

        this.dtOptions = {
          pagingType: 'full_numbers',
          pageLength: 10,
          stateSave: true,
          lengthMenu: [
            [10, 20, 30, -1],
            [10, 20, 30, 'All'],
          ],
          processing: true,
          destroy: true,
          searching: true,
        };
        this.rerender();
        this.show = true;
        this.spinner.hide();
      });

    this.filterForm = this.formBuilder.group({
      fromDate: [],
      toDate: [],
    });
  }

  submitFilterForm() {
    this.spinner.show();
    this.appointmentService
      .getAppointments(
        null,
        null,
        this.status,
        null,
        this.filterForm.controls['fromDate'].value,
        this.filterForm.controls['toDate'].value
      )
      .subscribe((res: any) => {
        this.appointments = res.data;
        if (this.appointments.length > 0) {
          this.appointments = this.appointments.sort(
            (a: any, b: any) =>
              new Date(
                b.appointmentDetails.schedules[0].appointmentDate
              ).getTime() -
              new Date(
                a.appointmentDetails.schedules[0].appointmentDate
              ).getTime()
          );
        }

        this.dtOptions = {
          pagingType: 'full_numbers',
          pageLength: 10,
          stateSave: true,
          lengthMenu: [
            [10, 20, 30, -1],
            [10, 20, 30, 'All'],
          ],
          processing: true,
          destroy: true,
          searching: true,
        };
        this.rerender();
        this.show = true;
        this.spinner.hide();
      });
  }

  getAppointments() {}
  selectValue(value: string) {
    this.value = value;
  }
  setApptId(apptId: any, apptStatus: any) {
    this.isApptCompleted = false;

    if (apptStatus == 'COMPLETE' || apptStatus == 'CANCEL') {
      this.isApptCompleted = true;
    }

    this.apptId = apptId;
  }
  getTestTypes() {}
  addSurveys() {
    var surveys = this.surveys.surveysList
      .filter((opt: { checked: any }) => opt.checked)
      .map((opt: any) => opt);
    this.selectedSurveys = surveys;

    var tests = this.surveys.testsList
      .filter((opt: { checked: any }) => opt.checked)
      .map((opt: any) => opt);
    this.selectedTests = tests;

    let selectedDetails = {
      tests: this.selectedTests,
      surveys: this.selectedSurveys,
      appointmentId: this.apptId,
    };
    this.appointmentService
      .saveSurveyDetails(selectedDetails)
      .subscribe((res) => {
        location.reload();
      });
  }
  disableButton() {}

  getSortableTime(timeRangeStr: string) {
    return getSortableTime(timeRangeStr);
  }

  getSortableDate(dateStr: string): string {
    return getSortableDate(dateStr);
  }
}
